<template>
<div class="chapter">
<div class="inner_page">
<div id="Maps">
<div class="fig">
<p class="fig-img"><a id="page_viii"><img alt="" class="image" src="images/ufig_2.jpg"/></a></p><a id="page_viii">
<p class="fig-caption">Map 1: Fighter Command during the Battle of Britain, 1940. Diane Bricknell</p>
</a></div><a id="page_viii">
</a><div class="fig"><a id="page_viii">
</a><p class="fig-img"><a id="page_viii"></a><a id="page_ix"><img alt="" class="image" src="images/ufig_3.jpg"/></a></p><a id="page_ix">
<p class="fig-caption">Map 2: 11 Group during the Battle of Britain, 1940. Diane Bricknell</p>
</a></div><a id="page_ix">
</a></div><a id="page_ix">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?2b32a537